import { lazyNamed } from 'src/utils/lazyNamed';

const Accounts = {
  AccountsList: lazyNamed(() => import('./containers/AccountsList'), 'AccountsList'),
  AccountOverview: lazyNamed(() => import('./containers/AccountOverview'), 'AccountOverview'),
  AccountForm: lazyNamed(() => import('./containers/AccountForm'), 'AccountForm'),
  ConversionTrackerForm: lazyNamed(() => import('./containers/ConversionTrackerForm'), 'ConversionTrackerForm'),
};

export default Accounts;
